let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g4nE1")).then(() => parcelRequire('74vF4'));